import React, { useState } from "react";
import { Button, Form, Modal } from "reactstrap";
import "./UpdateUsdt.scss";
import { useDispatch } from "react-redux";
import { responseToaster } from "../../../../helperFunctions";
import CustomeButton from "../../Forms/CustomeButton/CustomeButton";
import { updateUsdt } from "../../../../redux/slices/transactionSlice";

const UpdateUsdt = ({ isOpen, txnId, onCloseUpdateUsdt, onGet }) => {
  const dispatch = useDispatch();
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const onClose = () => {
    onCloseUpdateUsdt();
  };

  const onUpdateUsdt = async () => {
    try {
      setIsButtonLoading(true);

      const payload = {
        txnId: txnId,
        isUsdt: 1,
      };

      const response = await dispatch(updateUsdt(payload)).unwrap();
      responseToaster(response);

      if (response?.status) {
        onClose();
        onGet();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsButtonLoading(false);
    }
  };

  return (
    <Form>
      <Modal
        isOpen={isOpen}
        toggle={onClose}
        className="update-manual-bank-modal"
        centered
      >
        <div className="modal-header">
          <h3 className="modal-title mt-0">Update USDT</h3>
          <i className="fa-solid fa-xmark cursor-pointer" onClick={onClose}></i>
        </div>

        <div className="modal-body">
          <p>Are you sure you want to update this transaction as USDT?</p>
        </div>

        <div className="modal-footer">
          <div className="d-flex justify-content-end button-space">
            <Button className="graybutton" onClick={onClose}>
              Cancel
            </Button>
            <CustomeButton
              className="submitbutton"
              onClick={onUpdateUsdt}
              isButtonLoading={isButtonLoading}
            >
              Submit
            </CustomeButton>
          </div>
        </div>
      </Modal>
    </Form>
  );
};

export default UpdateUsdt;
